import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import AdminLayout from '../../components/admin/AdminLayout';
import DashboardStats from '../../components/admin/DashboardStats';
import RecentActivities from '../../components/admin/RecentActivities';

const DashboardPage = () => {
  return (
    <AdminLayout>
      <Container fluid className="py-4">
        <h2 className="mb-4">Dashboard</h2>
        <DashboardStats />
        <Row className="mt-4">
          <Col>
            <RecentActivities />
          </Col>
        </Row>
      </Container>
    </AdminLayout>
  );
};

export default DashboardPage;
